import * as angular from "angular";
import {IController, IQService} from "angular";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {Subscription} from "rxjs";
import { DefaultDraftItem } from "../../models/default-draft-template.model";

export class PlanningDefaultDraftsViewCtrl implements IController {

  public drafts: DefaultDraftItem[] = [];
  private draftsSubscription: Subscription;

  constructor(private $q: IQService,
              private confirmDialogService: ConfirmDialogService,
              private $state,
              private planningTemplateDefaultDraftRequestsService,
              private splitService,
              private planningDefaultDraftsFacadeService,
              ) {}

  $onInit() {
    this.getDefaultDrafts(this.getQueryParams());

    this.draftsSubscription = this.planningDefaultDraftsFacadeService.selectAll().subscribe(drafts => {
      this.drafts = angular.copy(drafts);

    });
  }

  $onDestroy() {
    this.planningDefaultDraftsFacadeService.clearStore();
    this.draftsSubscription?.unsubscribe();
  }

  private getDefaultDrafts(params) {
    this.planningDefaultDraftsFacadeService.clearStore();
      this.planningDefaultDraftsFacadeService.getMany(params);
  }

  private getQueryParams() {
    return {
      limit: 20
    };
  }


  // TODO: Restore edit functionality when draft names become editable
  // onEditDraft(draft: DefaultDraftItem) {
  //   const payload = {
  //     id: draft.id,
  //     name: draft.name,
  //     saveSettings: true
  //   } as any;

  //   this.planningDefaultDraftsFacadeService.renameDraft(draft.id, payload);
  // }

  fetchNext() {
    this.planningDefaultDraftsFacadeService.fetchNext(this.getQueryParams());
  }


  onDeleteDraft(draft: DefaultDraftItem) {
    this.confirmDialogService
      .confirm('Delete Default Draft', 'Are you sure you want to delete this default draft?')
      .then(() => {
        this.planningDefaultDraftsFacadeService.deleteDraft(draft.id);
      })
      .catch(() => {});
  }
}

angular
  .module('bringoz.admin.planning')
  .component('planningDefaultDraftsView', {
    bindings: {},
    template: require('./planning-default-drafts-view.html').default,
    controller: PlanningDefaultDraftsViewCtrl
  });
